// AboutUs.jsx - SAME AS BEFORE
import React, { useEffect, useState, useRef } from 'react';
import "bootstrap/dist/css/bootstrap.min.css"
import "./About.css"
import ABU from '../../assets/ABU.jpg'
import QM from '../../assets/QM.jpg'
import CEO from '../../assets/CEO.jpg'
import cc from '../../assets/cc.jpg'
import pp from '../../assets/pp.jpg'
import oo from '../../assets/oo.jpg'
import ee from '../../assets/ee.jpg'

export default function AboutUs() {
  const stats = [
    { number: 45, label: "+ transformation experts" },
    { number: 2, label: "Satellite Offices" },
    { number: 3, label: "Countries" },
    { number: 7, label: "Services" }
  ];

  const StatCounter = React.memo(({ number, label }) => {
    const [count, setCount] = useState(0);
    const ref = useRef(null);
    const [hasAnimated, setHasAnimated] = useState(false);

    useEffect(() => {
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting && !hasAnimated) {
            setHasAnimated(true);
            let start = 0;
            const end = parseInt(number);
            const duration = 2500;
            const increment = end / (duration / 16);

            const timer = setInterval(() => {
              start += increment;
              if (start >= end) {
                setCount(end);
                clearInterval(timer);
              } else {
                setCount(Math.floor(start));
              }
            }, 16);
          }
        },
        { threshold: 0.5 }
      );

      if (ref.current) observer.observe(ref.current);
      return () => observer.disconnect();
    }, [number, hasAnimated]);

    return (
      <div className="col-lg-3 col-md-6" ref={ref}>
        <div className="stat-box p-4 h-100">
          <h2 className="stat-number" aria-label={`${count} ${label}`}>
            {count.toLocaleString()}
          </h2>
          <p className="stat-label">{label}</p>
        </div>
      </div>
    );
  });

  return (
    <div className="App">
      {/* 1. HERO SECTION */}
      <section className="hero-section" style={{ backgroundImage: `url(${ABU})`, backgroundSize: "cover", backgroundPosition: "center", backgroundRepeat: "no-repeat", position: "relative" }}>
        <div className="hero-overlay" />
        <div className="container hero-content">

<h1 className="display-3 fw-bold text-white mb-4" style={{ textAlign: 'center' }}>
  About Us
</h1>
          <p className="text-white lead">We transform enterprises worldwide with precision and excellence. <br /><br /></p>
        </div>
        <svg className="hero-wave-bottom" viewBox="0 0 1440 150" preserveAspectRatio="none">
          <path d="M0,80 C360,0 1080,160 1440,80 L1440,150 L0,150 Z" fill="#f8f9fa" />
        </svg>
      </section>

      {/* 2. WHO WE ARE & WHO WE SERVE */}
      <section className="py-5 bg-light">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 mb-4">
              <h2 className="section-title who-we-are-title mb-3">Who We Are</h2>
              <div className="title-underline-perfect mb-4"></div>
              <p className="text-muted">
                blukraft is a services-focused arm of risposta®, created to help enterprises, 
                mid-market organizations, startups, and group companies design, implement, 
                and operate intelligent supply chain solutions. We combine deep domain 
                expertise with AI/ML-driven execution to deliver faster outcomes, higher 
                adoption, and sustained business value. We work closely with customers and 
                partners to translate strategy into execution—across processes, platforms, 
                data, and people.
              </p>
            </div>
            <div className="col-lg-6 mb-4">
  <h2 className="section-title who-we-serve-title mb-3">Who We Serve</h2>
  <div className="title-underline-perfect mb-4"></div>
  <p className="text-muted">
    We serve:
    <ul>
      <li>Enterprises – Complex, multi-country supply chain transformations</li>
      <li>Mid-market organizations – Scalable, cost-effective implementations</li>
      <li>Startups – Rapid setup, lean execution, future-ready architectures</li>
      <li>Internal group companies – Shared services, platforms, execution excellence</li>
      <li>Partners & System Integrators – Delivery enablement, co-implementation</li>
    </ul>
  </p>
</div>

          </div>
        </div>
      </section>

      {/* 3. FOUNDERS VISION - REDUCED HEIGHT */}
      <section className="cards-section founders-vision-reduced">
        <div className="container position-relative">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <h1 className="mb-4 fw-bold hero-title text-dark">Founders Vision</h1>
              <p className="mb-4 hero-lead">
                At blukraft, we are building more than services - we are shaping the future of 
                enterprise transformation by marrying deep diagnostic expertise with flawless 
                execution. Our belief is simple: every business challenge is an opportunity to 
                diagnose, optimize, and lead with precision.
              </p>
              <p className="mb-4 hero-lead">
                From the very beginning, we've been obsessed with solving real-world problems 
                in a practical, scalable way. What sets us apart is not just the methodologies 
                we apply, but the way we think, the way we engage, and the way we deliver outcomes.
              </p>
              <h3 className="hero-lead-v">Sai Mudigonda</h3>
              <h3 className="hero-lead">Founder and CEO</h3>
            </div>
            <div className="col-lg-6 d-flex justify-content-center align-items-center">
              <div className="row g-4 hero-card-grid">
                <div className="col-6">
                  <div>
                    <img src={CEO} alt="Sai Mudigonda, Founder & CEO" className="hero-card-icon hero-ceo-icon" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 4. WHAT WE DO */}
      <section className="py-5">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 mb-4">
              <img src={QM} alt="blukraft Supply Chain Solutions" className="img-fluid rounded-4 shadow-lg enlarged-ceo" />
            </div>
           <div className="col-lg-6 mb-4">
  <h2 className="section-title what-we-do-title mb-3">What We Do</h2>
  <div className="title-underline-perfect mb-4"></div>
  <p className="text-muted">
    Our core offerings include:
    <ul>
      <li>Supply Chain Implementation Services – End-to-end deployment of intelligent supply chain platforms</li>
      <li>Managed Services & Application Support (AMS) – 24/7 operations, continuous optimization, proactive support</li>
      <li>Data & Integration Services – Real-time data pipelines, API integrations, analytics platforms</li>
    </ul>
  </p>
</div>

          </div>
        </div>
      </section>

      {/* 5. ANIMATED STATS */}
      <section className="stats-section">
        {/* <svg className="wave-top-dark" viewBox="0 0 1440 150" preserveAspectRatio="none">
          <path d="M0,0 C360,-50 1080,-50 1440,0 L1440,150 L0,150 Z" fill="#2d3748" />
        </svg> */}
        <div className="container">
          <div className="row text-center g-4">
            {stats.map((stat, index) => (
              <StatCounter key={index} number={stat.number} label={stat.label} />
            ))}
          </div>
        </div>
        <svg className="wave-bottom-light" viewBox="0 0 1440 150" preserveAspectRatio="none">
          <path d="M0,80 C360,0 1080,160 1440,80 L1440,150 L0,150 Z" fill="#f8f9fa" />
        </svg>
      </section>

      {/* 6. CORE VALUES */}
      <section className="py-5 bg-light">
        <div className="container">
          <div className="text-center mb-5">
            <h2 className="section-title core-values-title mb-3">Our Core Values</h2>
            <div className="title-underline-perfect mb-4 mx-auto"></div>
          </div>
          <div className="row g-4">
            <div className="col-lg-3 col-md-6 col-sm-6">
              <div className="team-card h-100">
                <img src={oo} alt="Outcome Ownership Icon" className="team-img" />
                <div className="team-content p-4">
                  <h5 className="team-name mb-2">Outcome Ownership</h5>
                  <p className="team-position">We take responsibility for measurable business results, not just delivery.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-6">
              <div className="team-card h-100">
                <img src={ee} alt="Execution Excellence Icon" className="team-img" />
                <div className="team-content p-4">
                  <h5 className="team-name mb-2">Execution Excellence</h5>
                  <p className="team-position">We bring discipline, precision, and consistency to every engagement.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-6">
              <div className="team-card h-100">
                <img src={cc} alt="Context-Driven Delivery Icon" className="team-img" />
                <div className="team-content p-4">
                  <h5 className="team-name mb-2">Context-Driven Delivery</h5>
                  <p className="team-position">We design and execute solutions grounded in local realities and industry context.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-6">
              <div className="team-card h-100">
                <img src={pp} alt="Trusted Partnership Icon" className="team-img" />
                <div className="team-content p-4">
                  <h5 className="team-name mb-2">Trusted Partnership</h5>
                  <p className="team-position">We work as long-term partners, built on transparency, trust, and shared accountability.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
